(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jasper-product-v2"] && !Shopify.designMode) return;
  try {
    
class JasperProductV2 extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form = this.querySelector('.jv-product-form');
    this.slides = [...this.querySelectorAll('.jv-slide')];
    this.thumbs = [...this.querySelectorAll('.jv-thumb')];
    this.index = Math.max(0, this.slides.findIndex(s => !s.hidden));
    this.current = this.variants.find(v => String(v.id) === this.querySelector("[data-variant-id]").value) || this.variants[0];
    this.querySelector("[data-variant-id]").disabled = false;
    this.cartItems = [];
    const selectedMedia = this.slides.findIndex(s => s.dataset.mediaId === String(this.current?.media_id));
    if (selectedMedia >= 0 && new URLSearchParams(location.search).has('variant')) this.index = selectedMedia;
    this.listen(this, 'click', e => this.click(e));
    this.listen(this.form, 'change', e => {
      if (e.target.matches('[data-option]')) this.selectVariant();
      if (e.target.name === 'quantity') this.quantity();
    });
    this.listen(this.form, 'submit', e => { if (this.dataset.nativeCart === 'true') { this.quantity(); return; } e.preventDefault(); this.addToCart(); });
    this.listen(this.querySelector('.jv-tabs'), 'keydown', e => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      const tabs = [...this.querySelectorAll('.jv-tab')];
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[n].click(); tabs[n].focus();
    });
    this.querySelectorAll('dialog').forEach(dialog => {
      this.listen(dialog, 'click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
      this.listen(dialog, 'close', () => { if(dialog.classList.contains('jv-video-dialog')) this.querySelector('.jv-video-host').replaceChildren(); });
    });
    this.listen(this.querySelector('.jv-lightbox'), 'keydown', e => {
      if (e.key === 'ArrowRight') this.showImage(this.index + 1);
      if (e.key === 'ArrowLeft') this.showImage(this.index - 1);
    });
    const stage = this.querySelector('.jv-stage');
    let swipe = null;
    this.listen(stage, 'keydown', e => {
      if (e.target !== stage || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault();
      this.showImage(e.key === 'Home' ? 0 : e.key === 'End' ? this.slides.length - 1 : this.index + (e.key === 'ArrowRight' ? 1 : -1));
    });
    this.listen(stage, 'touchstart', e => {
      swipe = e.touches.length === 1 && !e.target.closest('button, video, iframe, model-viewer')
        ? {x:e.touches[0].clientX, y:e.touches[0].clientY} : null;
    });
    this.listen(stage, 'touchcancel', () => { swipe = null; });
    this.listen(stage, 'touchend', e => {
      if (!swipe || !e.changedTouches.length) return;
      const dx = e.changedTouches[0].clientX - swipe.x;
      const dy = e.changedTouches[0].clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.showImage(this.index + (dx < 0 ? 1 : -1));
    });
    try { this.querySelector('.jv-wishlist').setAttribute('aria-pressed', localStorage.getItem('jasper-wishlist-'+this.dataset.productId) === '1' ? 'true':'false'); } catch {}
    const clock=this.querySelector('[data-sale-end]');
    if(clock) {
      const end=Date.parse(clock.dataset.saleEnd);
      const tick=()=>{const remaining=Math.max(0,Math.floor((end-Date.now())/1000));if(!Number.isFinite(end)||remaining===0){clock.hidden=true;clearInterval(this.clockTimer);return;}for(const [key,value] of Object.entries({hours:Math.floor(remaining/3600),minutes:Math.floor(remaining/60)%60,seconds:remaining%60}))clock.querySelector('[data-time="'+key+'"]').textContent=String(value).padStart(2,'0');};
      tick();this.clockTimer=setInterval(tick,1000);
    }
    this.listen(window, 'popstate', () => { const id=new URL(location.href).searchParams.get('variant'); const variant=this.variants.find(v=>String(v.id)===id) || this.variants[0]; if(!variant)return; this.current=variant; this.querySelectorAll('.jv-options fieldset').forEach((f,i)=>f.querySelectorAll('input').forEach(input=>input.checked=input.value===variant.options[i])); this.syncVariant(false); if(variant.media_id){const n=this.slides.findIndex(s=>s.dataset.mediaId===String(variant.media_id));if(n>=0)this.showImage(n);} });
    this.syncVariant(false);
    this.showImage(this.index);
  }
  disconnectedCallback() { this.controller?.abort(); clearInterval(this.clockTimer); this.ready = false; }
  listen(node,event,fn) { node?.addEventListener(event,fn,{signal:this.controller.signal}); }
  click(e) {
    const b=e.target.closest('button'); if(!b || !this.contains(b)) return;
    if(b.matches('.jv-thumb')) this.showImage(this.thumbs.indexOf(b));
    if(b.matches('.jv-next,.jv-light-next')) this.showImage(this.index+1);
    if(b.matches('.jv-prev,.jv-light-prev')) this.showImage(this.index-1);
    if(b.matches('.jv-zoom')) { const img=this.slides[this.index]?.querySelector('img') || (this.slides[this.index]?.tagName==='IMG' ? this.slides[this.index] : null); if(img) { this.querySelector('.jv-lightbox>img').src=img.currentSrc || img.src; this.querySelector('.jv-lightbox>img').alt=img.alt; this.querySelector('.jv-lightbox').showModal(); } }
    if(b.matches('.jv-close,.jv-continue')) b.closest('dialog').close();
    if(b.matches('[data-quantity]')) this.quantity(Number(b.dataset.quantity));
    if(b.matches('.jv-tab')) this.selectTab(b);
    if(b.matches('.jv-spec-more')) { const expanded=b.getAttribute('aria-expanded')==='true'; b.setAttribute('aria-expanded',String(!expanded)); b.closest('.jv-panel').querySelectorAll('[data-extra-spec]').forEach(x=>x.hidden=expanded); }
    if(b.matches('.jv-wishlist')) { const state=b.getAttribute('aria-pressed')!=='true'; b.setAttribute('aria-pressed',String(state)); try{localStorage.setItem('jasper-wishlist-'+this.dataset.productId,state?'1':'0');}catch{} }
    if(b.matches('.jv-video')) this.openVideo(b);
    if(b.matches('.jv-menu-toggle')) { const menu=this.querySelector('.jv-mobile-menu'); menu.hidden=!menu.hidden;b.setAttribute('aria-expanded',String(!menu.hidden)); }
    if(b.matches('.jv-open-cart')) this.openCart();
  }
  quantity(delta=0) {
    const input=this.form.elements.quantity;
    const value=Number(input.value);
    input.value=String(Math.max(1,Math.min(9999,(Number.isFinite(value)?Math.floor(value):1)+delta)));
    this.querySelector('[data-quantity="-1"]').disabled=Number(input.value)<=1;
    return Number(input.value);
  }
  selectTab(button) {
    this.querySelectorAll('.jv-tab').forEach(t=>{const active=t===button;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
    this.querySelectorAll('.jv-panel').forEach(p=>p.hidden=p.id!==button.getAttribute('aria-controls'));
    const tabIndex = [...this.querySelectorAll('.jv-tab')].indexOf(button);
    const imageTemplate = this.querySelector('[data-jv-context="'+tabIndex+'"]');
    const storyHost = this.querySelector('.jv-story .jv-video');
    if (imageTemplate && storyHost) {
      const nextImage = imageTemplate.content.firstElementChild;
      const currentImage = storyHost.querySelector('img');
      if (nextImage && currentImage?.getAttribute('src') !== nextImage.getAttribute('src')) {
        storyHost.replaceChildren(nextImage.cloneNode(true));
      }
    }
  }
  selectVariant() {
    const selected=[...this.querySelectorAll('.jv-options fieldset')].map(f=>f.querySelector('input:checked')?.value);
    this.current=this.variants.find(v=>v.options.every((option,i)=>option===selected[i]));
    this.syncVariant(true);
  }
  syncVariant(updateHistory) {
    const v=this.current;
    const button=this.querySelector('.jv-add');
    const stock=this.querySelector('[data-stock]');
    button.disabled=this.pending || !v?.available;
    this.querySelector('[data-add-label]').textContent=!v?this.dataset.unavailable:!v.available?this.dataset.soldOut:this.dataset.add;
    this.querySelector('[data-add-price]').textContent=v?' - '+v.price_text:'';
    this.querySelector('[data-price]').textContent=v?v.price_text:'';
    this.querySelector('[data-compare]').textContent=v && v.compare_at_price>v.price?v.compare_text:'';
    stock.textContent=!v?this.dataset.unavailable:v.available?this.dataset.inStock:this.dataset.soldOut;
    this.querySelector('[data-variant-id]').disabled=!v?.available;
    stock.classList.toggle('unavailable',!v?.available);
    const badge=this.querySelector('[data-discount]');
    const discount=v && v.compare_at_price>v.price?Math.round((1-v.price/v.compare_at_price)*100):0;
    badge.hidden=!discount;badge.textContent=discount+'% OFF';
    this.querySelector("[data-variant-id]").value=v?.id || '';
    this.querySelector('.jv-feedback').textContent='';
    if(!v) { if(updateHistory) {const u=new URL(location.href);u.searchParams.delete('variant');history.replaceState(null,'',u);} return;}
    if(updateHistory) {
      try {const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}catch{}
      if(v.media_id) {const index=this.slides.findIndex(s=>s.dataset.mediaId===String(v.media_id));if(index>=0)this.showImage(index);}
      else if(v.image) {const image=this.querySelector('[data-variant-image]');if(image){image.src=v.image;image.srcset='';const index=this.slides.indexOf(image);if(index>=0)this.showImage(index);}}
    }
    if(v.spec) {const spec=this.querySelector('[data-spec-image]');if(spec)spec.src=v.spec;}
    if(v.specValues) v.specValues.forEach((value,i)=>{const cell=this.querySelector('[data-spec-value="'+i+'"]');if(cell)cell.textContent=value;});
  }
  showImage(index) {
    if(!this.slides.length) return;
    this.index=(index+this.slides.length)%this.slides.length;
    this.slides.forEach((s,i)=>{s.hidden=i!==this.index;if(i!==this.index)s.querySelectorAll?.('video').forEach(v=>v.pause());});
    this.thumbs.forEach((t,i)=>t.setAttribute('aria-current',String(i===this.index)));
    const current=this.slides[this.index];const img=current.tagName==='IMG'?current:current.querySelector('img');
    this.querySelector('.jv-zoom').hidden=!img;
    this.querySelectorAll('.jv-prev,.jv-next,.jv-light-prev,.jv-light-next').forEach(button => { button.hidden=this.slides.length < 2; });
    if (img) img.loading='eager';
    const thumb = this.thumbs[this.index];
    const rail = thumb?.parentElement;
    if (rail && rail.getBoundingClientRect && thumb.getBoundingClientRect) {
      const r = rail.getBoundingClientRect(), t = thumb.getBoundingClientRect();
      if (t.left < r.left) rail.scrollLeft += t.left-r.left;
      else if (t.right > r.right) rail.scrollLeft += t.right-r.right;
      if (t.top < r.top) rail.scrollTop += t.top-r.top;
      else if (t.bottom > r.bottom) rail.scrollTop += t.bottom-r.bottom;
    }
    if(img && this.querySelector('.jv-lightbox').open){const zoom=this.querySelector('.jv-lightbox>img');zoom.src=img.currentSrc||img.src;zoom.alt=img.alt;}
    this.querySelector('.jv-counter').textContent=(this.index+1)+' / '+this.slides.length;
  }
  async addToCart() {
    if(this.pending || !this.current?.available) return;
    this.pending=true;const button=this.querySelector('.jv-add');const label=this.querySelector('[data-add-label]');
    button.disabled=true;label.textContent=this.dataset.adding;
    try {
      const qty=this.quantity();const variant=this.current;
      if(this.dataset.mode==='demo') {
        const item=this.cartItems.find(x=>x.id===this.current.id);
        if(item)item.quantity+=qty;else this.cartItems.push({id:this.current.id,title:this.current.title,quantity:qty,price:this.current.price,price_text:this.current.price_text});
      } else {
        const root=this.dataset.cartRoot || '/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:qty}]})});
        const result=await response.json();if(!response.ok)throw new Error(result.description || this.dataset.error);
        this.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{items:result.items}}));
      }
      this.querySelector('.jv-feedback').textContent=this.dataset.added;
      await this.openCart();
    } catch(err){ this.querySelector('.jv-feedback').textContent=err.message || this.dataset.error; }
    finally{this.pending=false;button.disabled=!this.current?.available;label.textContent=this.current?.available?this.dataset.add:this.dataset.soldOut;}
  }
  async openCart() {
    const dialog=this.querySelector('.jv-cart');const container=this.querySelector('.jv-cart-items');container.replaceChildren();
    try {
      let items=this.cartItems;
      if(this.dataset.mode!=='demo') {const response=await fetch((this.dataset.cartRoot||'/')+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)throw new Error(this.dataset.error);items=(await response.json()).items;}
      items.forEach(item=>{const row=document.createElement('div');const name=document.createElement('strong');name.textContent=item.product_title || item.title;const detail=document.createElement('p');detail.textContent=(item.variant_title || '')+' × '+item.quantity;row.append(name,detail);container.append(row);});
      this.querySelector('.jv-cart-message').textContent=this.dataset.mode==='demo'?'Preview cart — no order or payment is created.':this.dataset.added;
      const link=this.querySelector('.jv-cart-link');link.hidden=this.dataset.mode==='demo';
      if(!dialog.open)dialog.showModal();
    } catch(err){this.querySelector('.jv-feedback').textContent=err.message || this.dataset.error;}
  }
  openVideo(button) {
    const raw=button.dataset.video;
    if(!raw)return;
    let url;try{url=new URL(raw);}catch{return;}
    const yt=url.hostname==='youtu.be'?url.pathname.slice(1):url.searchParams.get('v');
    let src='';
    if((url.hostname==='www.youtube.com'||url.hostname==='youtube.com'||url.hostname==='youtu.be') && /^[\w-]{11}$/.test(yt||''))src='https://www.youtube-nocookie.com/embed/'+yt+'?autoplay=1';
    if(url.hostname==='vimeo.com' && /^\/\d+$/.test(url.pathname))src='https://player.vimeo.com/video'+url.pathname;
    if(!src)return;
    const frame=document.createElement('iframe');frame.src=src;frame.title=button.getAttribute('aria-label');frame.allow='autoplay; fullscreen; picture-in-picture';frame.allowFullscreen=true;
    this.querySelector('.jv-video-host').replaceChildren(frame);this.querySelector('.jv-video-dialog').showModal();
  }
}
if(!customElements.get('jasper-product-v2'))customElements.define('jasper-product-v2',JasperProductV2);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jasper-product"] && !Shopify.designMode) return;
  try {
    
class JasperProduct extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.controller = new AbortController();
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.form = this.querySelector('.jp-product-form');
    this.slides = [...this.querySelectorAll('.jp-slide')];
    this.thumbs = [...this.querySelectorAll('.jp-thumb')];
    this.index = Math.max(0, this.slides.findIndex(s => !s.hidden));
    this.current = this.variants.find(v => String(v.id) === this.form.elements.id.value) || this.variants[0];
    this.form.elements.id.disabled = false;
    this.cartItems = [];
    const selectedMedia = this.slides.findIndex(s => s.dataset.mediaId === String(this.current?.media_id));
    if (selectedMedia >= 0 && new URLSearchParams(location.search).has('variant')) this.index = selectedMedia;
    this.listen(this, 'click', e => this.click(e));
    this.listen(this.form, 'change', e => {
      if (e.target.matches('[data-option]')) this.selectVariant();
      if (e.target.name === 'quantity') this.quantity();
    });
    this.listen(this.form, 'submit', e => { if (this.dataset.nativeCart === 'true') { this.quantity(); return; } e.preventDefault(); this.addToCart(); });
    this.listen(this.querySelector('.jp-tabs'), 'keydown', e => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      const tabs = [...this.querySelectorAll('.jp-tab')];
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      const n = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      tabs[n].click(); tabs[n].focus();
    });
    this.querySelectorAll('dialog').forEach(dialog => {
      this.listen(dialog, 'click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
      this.listen(dialog, 'close', () => { if(dialog.classList.contains('jp-video-dialog')) this.querySelector('.jp-video-host').replaceChildren(); });
    });
    this.listen(this.querySelector('.jp-lightbox'), 'keydown', e => {
      if (e.key === 'ArrowRight') this.showImage(this.index + 1);
      if (e.key === 'ArrowLeft') this.showImage(this.index - 1);
    });
    let startX = 0;
    const stage = this.querySelector('.jp-stage');
    this.listen(stage, 'touchstart', e => { startX = e.changedTouches[0].clientX; });
    this.listen(stage, 'touchend', e => { const delta = e.changedTouches[0].clientX - startX; if(Math.abs(delta)>45) this.showImage(this.index + (delta < 0 ? 1 : -1)); });
    try { this.querySelector('.jp-wishlist').setAttribute('aria-pressed', localStorage.getItem('jasper-wishlist-'+this.dataset.productId) === '1' ? 'true':'false'); } catch {}
    const clock=this.querySelector('[data-sale-end]');
    if(clock) {
      const end=clock.dataset.saleEnd==='demo'?Date.now()+(29*3600+10*60+26)*1000:Date.parse(clock.dataset.saleEnd);
      const tick=()=>{const remaining=Math.max(0,Math.floor((end-Date.now())/1000));if(!Number.isFinite(end)||remaining===0){clock.hidden=true;clearInterval(this.clockTimer);return;}for(const [key,value] of Object.entries({hours:Math.floor(remaining/3600),minutes:Math.floor(remaining/60)%60,seconds:remaining%60}))clock.querySelector('[data-time="'+key+'"]').textContent=String(value).padStart(2,'0');};
      tick();this.clockTimer=setInterval(tick,1000);
    }
    this.syncVariant(false);
    this.showImage(this.index);
  }
  disconnectedCallback() { this.controller?.abort(); clearInterval(this.clockTimer); this.ready = false; }
  listen(node,event,fn) { node?.addEventListener(event,fn,{signal:this.controller.signal}); }
  click(e) {
    const b=e.target.closest('button'); if(!b || !this.contains(b)) return;
    if(b.matches('.jp-thumb')) this.showImage(this.thumbs.indexOf(b));
    if(b.matches('.jp-next,.jp-light-next')) this.showImage(this.index+1);
    if(b.matches('.jp-prev,.jp-light-prev')) this.showImage(this.index-1);
    if(b.matches('.jp-zoom')) { const img=this.slides[this.index]?.querySelector('img') || (this.slides[this.index]?.tagName==='IMG' ? this.slides[this.index] : null); if(img) { this.querySelector('.jp-lightbox>img').src=img.currentSrc || img.src; this.querySelector('.jp-lightbox').showModal(); } }
    if(b.matches('.jp-close,.jp-continue')) b.closest('dialog').close();
    if(b.matches('[data-quantity]')) this.quantity(Number(b.dataset.quantity));
    if(b.matches('.jp-tab')) this.selectTab(b);
    if(b.matches('.jp-spec-more')) { const expanded=b.getAttribute('aria-expanded')==='true'; b.setAttribute('aria-expanded',String(!expanded)); b.closest('.jp-panel').querySelectorAll('[data-extra-spec]').forEach(x=>x.hidden=expanded); }
    if(b.matches('.jp-wishlist')) { const state=b.getAttribute('aria-pressed')!=='true'; b.setAttribute('aria-pressed',String(state)); try{localStorage.setItem('jasper-wishlist-'+this.dataset.productId,state?'1':'0');}catch{} }
    if(b.matches('.jp-video')) this.openVideo(b);
    if(b.matches('.jp-menu-toggle')) { const menu=this.querySelector('.jp-mobile-menu'); menu.hidden=!menu.hidden;b.setAttribute('aria-expanded',String(!menu.hidden)); }
    if(b.matches('.jp-open-cart')) this.openCart();
  }
  quantity(delta=0) {
    const input=this.form.elements.quantity;
    input.value=String(Math.max(1,Math.floor(Number(input.value)||1)+delta));
    this.querySelector('[data-quantity="-1"]').disabled=Number(input.value)<=1;
    return Number(input.value);
  }
  selectTab(button) {
    this.querySelectorAll('.jp-tab').forEach(t=>{const active=t===button;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});
    this.querySelectorAll('.jp-panel').forEach(p=>p.hidden=p.id!==button.getAttribute('aria-controls'));
  }
  selectVariant() {
    const selected=[...this.querySelectorAll('.jp-options fieldset')].map(f=>f.querySelector('input:checked')?.value);
    this.current=this.variants.find(v=>v.options.every((option,i)=>option===selected[i]));
    this.syncVariant(true);
  }
  syncVariant(updateHistory) {
    const v=this.current;
    const button=this.querySelector('.jp-add');
    const stock=this.querySelector('[data-stock]');
    button.disabled=!v?.available;
    this.querySelector('[data-add-label]').textContent=!v?this.dataset.unavailable:!v.available?this.dataset.soldOut:this.dataset.add;
    this.querySelector('[data-add-price]').textContent=v?' - '+v.price_text:'';
    this.querySelector('[data-price]').textContent=v?v.price_text:'';
    this.querySelector('[data-compare]').textContent=v && v.compare_at_price>v.price?v.compare_text:'';
    stock.textContent=!v?this.dataset.unavailable:v.available?this.dataset.inStock:this.dataset.soldOut;
    stock.classList.toggle('unavailable',!v?.available);
    const badge=this.querySelector('[data-discount]');
    const discount=v && v.compare_at_price>v.price?Math.round((1-v.price/v.compare_at_price)*100):0;
    badge.hidden=!discount;badge.textContent=discount+'% OFF';
    this.form.elements.id.value=v?.id || '';
    this.querySelector('.jp-feedback').textContent='';
    if(!v) return;
    if(updateHistory) {
      try {const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}catch{}
      if(v.media_id) {const index=this.slides.findIndex(s=>s.dataset.mediaId===String(v.media_id));if(index>=0)this.showImage(index);}
      else if(v.image) {const image=this.querySelector('[data-variant-image]');if(image){image.src=v.image;image.srcset='';const index=this.slides.indexOf(image);if(index>=0)this.showImage(index);}}
    }
    if(v.spec) {const spec=this.querySelector('[data-spec-image]');if(spec)spec.src=v.spec;}
    if(v.specValues) v.specValues.forEach((value,i)=>{const cell=this.querySelector('[data-spec-value="'+i+'"]');if(cell)cell.textContent=value;});
  }
  showImage(index) {
    if(!this.slides.length) return;
    this.index=(index+this.slides.length)%this.slides.length;
    this.slides.forEach((s,i)=>{s.hidden=i!==this.index;if(i!==this.index)s.querySelectorAll?.('video').forEach(v=>v.pause());});
    this.thumbs.forEach((t,i)=>t.setAttribute('aria-current',String(i===this.index)));
    const current=this.slides[this.index];const img=current.tagName==='IMG'?current:current.querySelector('img');
    this.querySelector('.jp-zoom').hidden=!img;
    if(img){const zoom=this.querySelector('.jp-lightbox>img');zoom.src=img.currentSrc||img.src;zoom.alt=img.alt;}
    this.querySelector('.jp-counter').textContent=(this.index+1)+' / '+this.slides.length;
  }
  async addToCart() {
    if(this.pending || !this.current?.available) return;
    this.pending=true;const button=this.querySelector('.jp-add');const label=this.querySelector('[data-add-label]');
    button.disabled=true;label.textContent=this.dataset.adding;
    try {
      const qty=this.quantity();
      if(this.dataset.mode==='demo') {
        const item=this.cartItems.find(x=>x.id===this.current.id);
        if(item)item.quantity+=qty;else this.cartItems.push({id:this.current.id,title:this.current.title,quantity:qty,price:this.current.price,price_text:this.current.price_text});
      } else {
        const root=this.dataset.cartRoot || '/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.current.id,quantity:qty}]})});
        const result=await response.json();if(!response.ok)throw new Error(result.description || this.dataset.error);
        this.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{items:result.items}}));
      }
      this.querySelector('.jp-feedback').textContent=this.dataset.added;
      await this.openCart();
    } catch(err){ this.querySelector('.jp-feedback').textContent=err.message || this.dataset.error; }
    finally{this.pending=false;button.disabled=!this.current?.available;label.textContent=this.current?.available?this.dataset.add:this.dataset.soldOut;}
  }
  async openCart() {
    const dialog=this.querySelector('.jp-cart');const container=this.querySelector('.jp-cart-items');container.replaceChildren();
    try {
      let items=this.cartItems;
      if(this.dataset.mode!=='demo') {const response=await fetch((this.dataset.cartRoot||'/')+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)throw new Error(this.dataset.error);items=(await response.json()).items;}
      items.forEach(item=>{const row=document.createElement('div');const name=document.createElement('strong');name.textContent=item.product_title || item.title;const detail=document.createElement('p');detail.textContent=(item.variant_title || '')+' × '+item.quantity;row.append(name,detail);container.append(row);});
      this.querySelector('.jp-cart-message').textContent=this.dataset.mode==='demo'?'Preview cart — no order or payment is created.':this.dataset.added;
      const link=this.querySelector('.jp-cart-link');link.hidden=this.dataset.mode==='demo';
      if(!dialog.open)dialog.showModal();
    } catch(err){this.querySelector('.jp-feedback').textContent=err.message || this.dataset.error;}
  }
  openVideo(button) {
    const raw=button.dataset.video;
    if(!raw)return;
    let url;try{url=new URL(raw);}catch{return;}
    const yt=url.hostname==='youtu.be'?url.pathname.slice(1):url.searchParams.get('v');
    let src='';
    if((url.hostname==='www.youtube.com'||url.hostname==='youtube.com'||url.hostname==='youtu.be') && /^[\w-]{11}$/.test(yt||''))src='https://www.youtube-nocookie.com/embed/'+yt+'?autoplay=1';
    if(url.hostname==='vimeo.com' && /^\/\d+$/.test(url.pathname))src='https://player.vimeo.com/video'+url.pathname;
    if(!src)return;
    const frame=document.createElement('iframe');frame.src=src;frame.title=button.getAttribute('aria-label');frame.allow='autoplay; fullscreen; picture-in-picture';frame.allowFullscreen=true;
    this.querySelector('.jp-video-host').replaceChildren(frame);this.querySelector('.jp-video-dialog').showModal();
  }
}
if(!customElements.get('jasper-product'))customElements.define('jasper-product',JasperProduct);


  } catch(e) { console.error(e); }
})();
})();
